/* Board 9 lane B9B (2026-10-31): the rail indicator and the laptop end spring.
   Loaded (deferred) by layout/theme.liquid only when umbra_rail_indicator is not "line" or umbra_rail_bleed is on.
   - Indicator (html.ub9-ind-dots / -count / -none): today's line keeps its box but is hidden (assets/umbra-b9b-rails.css);
     dots or a "1 / 3" count are laid over the place where it sat, so nothing below a rail moves. Designer Picks has no
     line; its dots sit in the space its bleed reserves under the cards. One page = the cards in view at that width.
   - Spring (html.ub9-bleed): on laptops a further sideways trackpad or wheel pull at either end moves the cards with
     resistance, offset = (1 - 1 / (d * 0.55 / W + 1)) * W, and they spring back (420 ms, the house curve) about 140 ms
     after the input stops or when a mouse drag is released. Transform on the list items only (the list keeps its width,
     so the scroll range never shrinks under the pull). Touch keeps the browser's own bounce; desktop Safari bounces on
     its own, so it is skipped; reduced motion gets none; the arrows and the keyboard never bounce. Designer Picks keeps
     its own spring (sections/featured-collection.liquid, fc-bleed), which umbra_rail_spring off also stops (B10J-1). Meet the designers is a loop and is left alone. */
(function () {
  if (window.UmbraB9Rails) return;
  var root = document.documentElement;
  var m = /\bub9-ind-(dots|count|none)\b/.exec(root.className);
  var MODE = m ? m[1] : 'line';
  var BLEED = /\bub9-bleed\b/.test(root.className);
  /* B10F-3: umbra_rail_spring off (html.ub9-nospring) keeps the bleed and the indicator and drops the laptop end spring. */
  var SPRING = !/\bub9-nospring\b/.test(root.className);
  var me = document.currentScript;
  var OF = (me && me.getAttribute('data-ub9-of')) || 'of';
  var red = matchMedia('(prefers-reduced-motion: reduce)');
  var fine = matchMedia('(hover: hover) and (pointer: fine)');
  var ua = navigator.userAgent;
  /* SAFARI = the browser bounces by itself: desktop Safari, every iOS/iPadOS browser (WebKit; an iPad trackpad sends
     wheel events) and Firefox on a Mac. Chrome, Edge and Firefox on Windows keep the spring. */
  var SAFARI = (/Safari\//.test(ua) && !/(Chrome|Chromium|Edg|OPR|Android)\//.test(ua)) || /(CriOS|FxiOS|EdgiOS)\//.test(ua) || (/Macintosh/.test(ua) && /Firefox\//.test(ua));
  var EASE = 'cubic-bezier(0.22, 0.61, 0.36, 1)';

  function slotOs(sl) {
    var host = sl.parentElement;
    var el = host && host.querySelector(':scope > .os-scrollbar-horizontal');
    return el ? { host: host, el: el } : null;
  }
  function slotFcb(sl) {
    var box = sl.closest('.fc-bleed'), host = sl.parentElement;
    if (!box || !host) return null;
    return { host: host, box: box, sl: sl };
  }
  function slotWander(sl) {
    var sec = sl.closest('.uw');
    if (sec && sec.getAttribute('data-indicator') === 'line') return null; /* B10D-2: the section keeps its own line */
    var el = sec && sec.querySelector('.uw__track');
    return el ? { host: el.parentElement, el: el } : null;
  }
  function slotLine(sl) {
    var sec = sl.closest('.shopify-section');
    var el = sec && sec.querySelector('.umbra-rail-line');
    return el ? { host: el.parentElement, el: el, rel: true } : null;
  }
  var TYPES = [
    { sel: '#main-content carousel-slider .featured-collection-products > .slider', list: '.slider__grid', slot: slotOs },
    { sel: '#main-content .fc-bleed .slider', list: '.slider__grid', slot: slotFcb, own: true },
    { sel: '#main-content .uw .uw__row', slot: slotWander },
    { sel: '#main-content .umbra-gifts > .umbra-gifts__grid' },
    { sel: '#main-content .umbra-pdp-rail .products-grid-container > ul, #main-content product-recommendations .products-grid-container > ul', slot: slotLine }
  ];

  function attach(sl, t) {
    if (sl.__ub9) return;
    sl.__ub9 = true;
    var list = function () { return t.list ? sl.querySelector(t.list) : sl; };
    var W = 0, max = 0, x = sl.scrollLeft, targets = [0], raf = 0;
    var ind = null, slot = null, dots = [], count = null, active = -1;

    /* Pages: one per set of whole cards in view; targets are the scroll positions of each page's first column. */
    function measure() {
      W = sl.clientWidth;
      max = Math.max(0, sl.scrollWidth - W);
      x = sl.scrollLeft;
      var ls = list();
      targets = [0];
      if (!ls || max < 2) return;
      var sr = sl.getBoundingClientRect(), cols = [];
      Array.prototype.forEach.call(ls.children, function (li) {
        var r = li.getBoundingClientRect();
        if (r.width < 2) return;
        var cx = Math.round(r.left - sr.left + x);
        if (!cols.length || Math.abs(cols[cols.length - 1] - cx) > 2) cols.push(cx);
      });
      cols.sort(function (a, b) { return a - b; });
      if (cols.length < 2) return;
      var pitch = cols[1] - cols[0];
      var cs = getComputedStyle(sl);
      var pad = parseFloat(cs.scrollPaddingLeft) || 0;
      var gap = pitch - (ls.children[0] ? ls.children[0].getBoundingClientRect().width : pitch);
      var view = W - 2 * pad;
      var per = Math.max(1, Math.floor((view + Math.max(0, gap)) / pitch + 0.05));
      targets = [];
      for (var i = 0; i < cols.length; i += per) {
        var tx = Math.min(max, Math.max(0, cols[i] - cols[0]));
        if (targets.length && tx >= max) { targets.push(max); break; }
        targets.push(tx);
      }
      if (targets[targets.length - 1] < max - 2) targets.push(max);
    }
    function current() {
      if (x >= max - 2 && max > 0) return targets.length - 1;
      var best = 0;
      for (var i = 1; i < targets.length; i++) if (Math.abs(targets[i] - x) < Math.abs(targets[best] - x)) best = i;
      return best;
    }

    /* Indicator */
    function build() {
      if (MODE === 'line' || MODE === 'none' || !t.slot) return;
      slot = t.slot(sl);
      if (!slot) return;
      if (ind && ind.isConnected) return;
      ind = document.createElement('div');
      ind.className = 'ub9-ind ub9-ind--' + MODE;
      if (MODE === 'count') {
        count = document.createElement('span');
        count.className = 'ub9-ind__count';
        count.setAttribute('aria-hidden', 'true');
        ind.appendChild(count);
      }
      if (slot.rel && getComputedStyle(slot.host).position === 'static') slot.host.style.position = 'relative';
      slot.host.appendChild(ind);
      dots = [];
      active = -1;
    }
    function place() {
      if (!ind || !slot) return;
      var hr = slot.host.getBoundingClientRect(), left, width, mid;
      if (slot.box) {
        var br = slot.box.getBoundingClientRect(), r = slot.sl.getBoundingClientRect();
        var pb = parseFloat(getComputedStyle(slot.box).paddingBottom) || 0;
        left = br.left; width = br.width; mid = r.bottom + pb / 2;
      } else {
        var er = slot.el.getBoundingClientRect();
        left = er.left; width = er.width; mid = er.top + er.height / 2;
      }
      ind.style.left = (left - hr.left - slot.host.clientLeft) + 'px';
      ind.style.width = width + 'px';
      ind.style.top = (mid - hr.top - slot.host.clientTop - 22) + 'px';
    }
    function render() {
      if (!ind) return;
      var n = targets.length;
      ind.hidden = n < 2;
      if (n < 2) return;
      if (MODE === 'dots' && dots.length !== n) {
        while (ind.firstChild) ind.removeChild(ind.firstChild);
        dots = [];
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ub9-ind__dot';
          b.setAttribute('aria-label', (i + 1) + ' ' + OF + ' ' + n);
          b.addEventListener('click', go.bind(null, i));
          ind.appendChild(b);
          dots.push(b);
        }
        active = -1;
      }
      var a = current();
      if (a === active) return;
      active = a;
      if (MODE === 'dots') dots.forEach(function (b, i) { if (i === a) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
      else if (count) count.textContent = (a + 1) + ' / ' + n;
    }
    function go(i) {
      var tx = targets[i] || 0;
      sl.scrollTo({ left: tx, behavior: red.matches ? 'auto' : 'smooth' });
    }
    function paint() { raf = 0; x = sl.scrollLeft; render(); }
    function layout() { build(); measure(); place(); render(); }

    /* Spring (laptops) */
    /* live: a pull or its spring back is running. For that whole time the row's scroll snap is off (inline), or a
       mandatory snap re-snaps scrollLeft toward the moved items mid-pull; finish() always restores it. */
    var d = 0, dir = 0, idle = 0, sraf = 0, clearT = 0, drag = null, live = false;
    function items() { var ls = list(); return ls ? ls.children : []; }
    function setT(o, anim) {
      var its = items();
      for (var i = 0; i < its.length; i++) {
        var s = its[i].style;
        s.transition = anim ? 'transform 420ms ' + EASE : 'none';
        s.transform = o ? 'translate3d(' + o.toFixed(2) + 'px,0,0)' : '';
      }
    }
    function applyPull() { sraf = 0; setT(d > 0 ? (1 - 1 / (d * 0.55 / W + 1)) * W * dir : 0, false); }
    function pull() {
      clearTimeout(clearT); clearT = 0;
      if (!live) { live = true; sl.style.scrollSnapType = 'none'; }
      if (!sraf) sraf = requestAnimationFrame(applyPull);
    }
    function finish() {
      clearTimeout(clearT); clearT = 0;
      var its = items();
      for (var i = 0; i < its.length; i++) its[i].style.transition = '';
      sl.style.scrollSnapType = '';
      live = false;
    }
    function release() {
      clearTimeout(idle);
      if (sraf) { cancelAnimationFrame(sraf); sraf = 0; }
      if (!live) return;
      d = 0; dir = 0;
      setT(0, true);
      clearTimeout(clearT);
      clearT = setTimeout(finish, 460);
    }
    /* A tab switch mid-pull or mid-spring: settle at once so the snap is never left off. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden || !live) return;
      clearTimeout(idle);
      if (sraf) { cancelAnimationFrame(sraf); sraf = 0; }
      d = 0; dir = 0; drag = null;
      setT(0, false);
      finish();
    });
    function springOn() { return BLEED && SPRING && !t.own && !SAFARI && fine.matches && !red.matches; }
    sl.addEventListener('wheel', function (e) {
      if (!springOn() || e.ctrlKey || max < 2) return;
      var dx = e.deltaMode === 1 ? e.deltaX * 16 : e.deltaX;
      if (Math.abs(dx) <= Math.abs(e.deltaY)) return;
      if (!d && clearT) {
        /* A new pull during the spring back starts from the on-screen offset: one read here, none in the move loop. */
        var its = items(), o = its[0] ? new DOMMatrix(getComputedStyle(its[0]).transform).m41 : 0;
        var a = Math.min(Math.abs(o), W * 0.98);
        if (a > 0.5 && W > 0) { dir = o > 0 ? 1 : -1; d = W * (1 / (1 - a / W) - 1) / 0.55; }
      }
      if (d > 0) {
        d = Math.max(0, d + (dir > 0 ? -dx : dx));
      } else if (x <= 0.5 && dx < 0) { dir = 1; d = -dx; }
      else if (x >= max - 1 && dx > 0) { dir = -1; d = dx; }
      else return;
      pull();
      clearTimeout(idle);
      idle = setTimeout(release, 140);
    }, { passive: true });
    sl.addEventListener('pointerdown', function (e) {
      if (!springOn() || e.pointerType !== 'mouse' || e.button !== 0 || !sl.classList.contains('is-grabbable')) return;
      drag = { x: e.clientX, left: x, id: e.pointerId };
    });
    sl.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      if (!(e.buttons & 1)) { up(e); return; }
      var want = drag.left - (e.clientX - drag.x);
      if (want < 0) { dir = 1; d = -want; pull(); }
      else if (want > max) { dir = -1; d = want - max; pull(); }
      else if (d) { d = 0; setT(0, false); }
    });
    function up(e) { if (!drag || e.pointerId !== drag.id) return; drag = null; release(); }
    window.addEventListener('pointerup', up);
    window.addEventListener('pointercancel', up);

    sl.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(paint); }, { passive: true });
    var lq = 0;
    function queueLayout() { if (!lq) lq = requestAnimationFrame(function () { lq = 0; layout(); }); }
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(queueLayout);
      ro.observe(sl);
      if (sl.parentElement) ro.observe(sl.parentElement);
    }
    window.addEventListener('resize', queueLayout, { passive: true });
    /* OverlayScrollbars adds its line after this runs; product rails get their cards later. */
    if ('MutationObserver' in window) {
      var mt = 0;
      new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(queueLayout, 120); }).observe(sl.parentElement || sl, { childList: true });
      var ls0 = list();
      if (ls0 && ls0 !== sl) new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(queueLayout, 120); }).observe(ls0, { childList: true });
    }
    layout();
  }

  function scan(ctx) {
    TYPES.forEach(function (t) {
      Array.prototype.forEach.call((ctx || document).querySelectorAll(t.sel), function (sl) { attach(sl, t); });
    });
  }
  var sq = 0;
  function later() { clearTimeout(sq); sq = setTimeout(function () { scan(); }, 250); }
  window.UmbraB9Rails = { scan: scan };
  function boot() {
    scan();
    var main = document.getElementById('MainContent') || document.getElementById('main-content');
    if (main && 'MutationObserver' in window) new MutationObserver(later).observe(main, { childList: true, subtree: true });
    window.addEventListener('load', later);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () { later(); });
})();
